
import React, { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

// Lazy‑load page components
const HomePage = lazy(() => import('../pages/home/page'));
const MethodPage = lazy(() => import('../pages/method/page'));
const ClinicalPage = lazy(() => import('../pages/clinical/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const EducationPage = lazy(() => import('../pages/education/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const fallback = <div>Loading...</div>;

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={fallback}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/about',
    element: (
      <Suspense fallback={fallback}>
        <AboutPage />
      </Suspense>
    ),
  },
  {
    path: '/method',
    element: (
      <Suspense fallback={fallback}>
        <MethodPage />
      </Suspense>
    ),
  },
  {
    path: '/clinical-services',
    element: (
      <Suspense fallback={fallback}>
        <ClinicalPage />
      </Suspense>
    ),
  },
  {
    path: '/education',
    element: (
      <Suspense fallback={fallback}>
        <EducationPage />
      </Suspense>
    ),
  },
  {
    path: '/product',
    element: (
      <Suspense fallback={fallback}>
        <ProductPage />
      </Suspense>
    ),
  },
  {
    path: '/booking',
    element: (
      <Suspense fallback={fallback}>
        <BookingPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={fallback}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;
